export default ExportData;

const $ = jQuery;

function ExportData(config) {
  const TYPE = {
    XML: {
      action: 'marc_xml',
      mimeType: 'text/xml',
      extension: '.xml',
    },
    MARC: {
      action: 'marc',
      mimeType: 'application/marc',
      extension: '.mrc'
    },
  };
  var dialog = undefined;
  var activeType;

  init();

  function init() {
    if (!config.id) return null;

    activeType = config.type === 'XML' ? TYPE.XML : TYPE.MARC;
    getData();
  }

  function getData() {
    var request = {
      type: "POST",
      dataType: "xml",
      async: true,
      cache: false,
      timeout: 0,
      url: config.ajaxUrl + '/' + activeType.action,
      data: {
        id: config.id,
      },
      success: function(response) {
          download(new XMLSerializer().serializeToString(response));
      },
      error: function(error) {
        dialog = initDialog();
        dialog ? dialog.dialog('open') : console.error('Nem található exportálható adat.');
      },
    };
    $.ajax(request);
  }

  function initDialog() {
    return config.dialog ? $(config.dialog).dialog({
      modal: true,
      buttons: {
        OK: function() {
          $(this).dialog('close');
        }
      }
    }) : undefined;
  }
  
  function download(content) {
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    var blob = new Blob([content], {type: activeType.mimeType});
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = config.id + '_' + moment(Date.now()).format('YYYYMMDDSS') + activeType.extension;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
}